module.exports = __webpack_public_path__ + "fonts/iconfont.04bc5c1.woff";